import { render } from "./BagOfWordsPractical.vue?vue&type=template&id=39c4e74e"
import script from "./BagOfWordsPractical.vue?vue&type=script&lang=js"
export * from "./BagOfWordsPractical.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__